import React from 'react';

import './banner.modules.css';

const BannerListHeader = () => {
    return (
        <div className='list-row header'>
            <div className='center id'>ID</div>
            <div className='flex-start name'>Наименование</div>
            <div className='center type'>Тип</div>
            <div className='center localization'>Локализация</div>
            <div className='center status'>Статус</div>
            <div className='center actions'>Действия</div>
        </div>
    )
};

export default BannerListHeader;